export default [
  {
    path: "/",
    name: "首页",
    component: () => import("@/views/Main"),
  },
  {
    path: "/user",
    name: "用户管理",
    component: () => import("@/views/system/User"),
  },
  {
    path: "/dept",
    name: "部门管理",
    component: () => import("@/views/system/Dept"),
  },
  {
    path: "/menu",
    name: "菜单管理",
    component: () => import("@/views/system/Menu"),
  },
  {
    path: "/role",
    name: "角色管理",
    component: () => import("@/views/system/Role"),
  },
  {
    path: "/dict",
    name: "字典管理",
    component: () => import("@/views/system/Dict"),
  },
  {
    path: "/config",
    name: "配置管理",
    component: () => import("@/views/system/Config"),
  },
  {
    path: "/dateInfo",
    name: "日期管理",
    component: () => import("@/views/DateInfo"),
  },
  {
    path: "/register/:date",
    name: "登记管理详情",
    component: () => import("@/views/Register"),
  },
  {
    path: "/object",
    name: "预约对象",
    component: () => import("@/views/VisitObject"),
  },
  {
    path: "/register",
    name: "注册列表",
    component: () => import("@/views/registerList"),
  },
  {
    path: '/visitor',
    name: '访客记录',
    component: () => import('@/views/visitor')
  },
  {
    path: '/filing-yaoping',
    name: '药品备案记录',
    component: () => import('@/views/filing-yaoping')
  },
  {
    path: '/filing-sheibei',
    name: '设备备案记录',
    component: () => import('@/views/filing-shebei')
  },
  {
    path: '/filing-haocai',
    name: '医用耗材备案记录',
    component: () => import('@/views/filing-haocai')
  },
  {
    path: '/visitApply-consumables',
    name: '医用耗材访问申请',
    component: () => import('@/views/visitApplyConsumables')
  },
  {
    path: '/visitApply-medicine',
    name: '药品访问申请',
    component: () => import('@/views/visitApplyMedicine')
  },
  {
    path: '/visitApply-equipment',
    name: '设备访问申请',
    component: () => import('@/views/visitApplyEquipment')
  },
];
